module.exports = __webpack_public_path__ + "static/media/reelflyfishing.6912723f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/reelflyfishing.png
// module id = 169
// module chunks = 0